import { render, staticRenderFns } from "./ranliaogl.vue?vue&type=template&id=1be20221&scoped=true&"
import script from "./ranliaogl.vue?vue&type=script&lang=js&"
export * from "./ranliaogl.vue?vue&type=script&lang=js&"
import style0 from "./ranliaogl.vue?vue&type=style&index=0&id=1be20221&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be20221",
  null
  
)

export default component.exports